export const articleData: Record<string, {
  id: number;
  title: string;
  category: string;
  tag: string;
  time: string;
  reads: string;
  author: string;
  image: string;
  content: string[];
  relatedArticles: number[];
}> = {
  '1': {
    id: 1,
    title: '某千万粉丝主播直播间突然被封，背后原因曝光',
    category: '网红黑料',
    tag: '爆',
    time: '2026年6月28日 14:22',
    reads: '85.2万',
    author: '吃瓜第一线',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20streaming%20studio%20with%20red%20warning%20alert%20on%20computer%20screen%2C%20dark%20atmosphere%2C%20cyberpunk%20aesthetic%2C%20neon%20pink%20accents%2C%20mysterious%20silhouette&width=1200&height=600&seq=article-detail-01&orientation=landscape',
    content: [
      '据知情人士透露，某拥有千万粉丝的头部主播在近日的直播过程中突然遭遇平台封禁，直播间在数秒内被强制关闭，令在场数十万观众措手不及。',
      '该主播此前一直以"全网最真实带货"为标签，积累了大量忠实粉丝。然而，据内部消息人士爆料，此次封禁并非偶然事件，而是平台在接到多起消费者投诉后的集中处理。',
      '据悉，该主播在近半年的直播带货中，多次涉及虚假宣传、售卖三无产品以及刷单行为。累计涉及的违规金额或超过千万元。平台方面在掌握了确凿证据后，决定对该账号进行永久封禁处理。',
      '此事在粉丝群体中引发了巨大震动。不少忠实粉丝表示难以置信，认为这是一场"阴谋"，是对该主播的打压。但也有理智粉丝表示，如果违规属实，应该接受相应处罚。',
      '业内人士分析认为，随着直播带货行业监管日趋严格，类似的封禁事件可能会越来越多。平台方也需要在商业利益和内容合规之间找到更好的平衡点。',
    ],
    relatedArticles: [2, 4, 8],
  },
  '2': {
    id: 2,
    title: '顶流女星深夜密会神秘男子，经纪人紧急公关',
    category: '明星八卦',
    tag: '独家',
    time: '2026年6月28日 14:08',
    reads: '120.6万',
    author: '八卦雷达',
    image: 'https://readdy.ai/api/search-image?query=Paparazzi%20night%20photography%20of%20luxury%20hotel%20entrance%2C%20blurred%20figures%2C%20warm%20golden%20street%20lights%2C%20mysterious%20atmosphere&width=1200&height=600&seq=article-detail-02&orientation=landscape',
    content: [
      '昨日深夜，本平台独家获得一组照片，显示某知名一线女星与一名身份不明的男子在某五星级酒店附近出现。两人举止亲密，后一同进入酒店，直至次日清晨才分别离开。',
      '该女星今年凭借多部热播剧人气飙升，一直以"单身专注事业"的形象示人。此次密会照片的曝光，无疑将对其公众形象造成巨大冲击。',
      '消息传出后数小时内，该女星的经纪团队连夜发布声明，称照片中的男子仅为"普通朋友"，两人当天是在进行"工作洽谈"，并强烈谴责偷拍行为侵犯了艺人的隐私权。',
      '然而，这一声明并未完全平息舆论。不少网友对比照片细节后指出，两人的互动显然超出"普通朋友"或"工作洽谈"的范畴。更有自称知情人士的网友透露，该男子并非圈外人，而是某投资公司的高管。',
      '截至目前，该女星本人尚未就此事做出任何公开回应。其社交媒体账号的评论区已被粉丝和路人网友的讨论淹没，话题热度持续攀升中。',
    ],
    relatedArticles: [1, 7, 11],
  },
  '3': {
    id: 3,
    title: '知名综艺录制现场爆发冲突，两位导师当场翻脸',
    category: '娱乐圈',
    tag: '爆',
    time: '2026年6月28日 13:45',
    reads: '96.3万',
    author: '圈内老鬼',
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20bright%20stage%20lights%2C%20two%20people%20in%20heated%20argument%20silhouette%2C%20dramatic%20red%20and%20blue%20lighting&width=1200&height=600&seq=article-detail-03&orientation=landscape',
    content: [
      '据现场观众爆料，在一档热门综艺节目最新一期录制过程中，两位导师因对一位选手的淘汰决定产生严重分歧，当场爆发激烈争吵。',
      '现场目击者描述，争吵从意见不合迅速升级为个人攻击。其中一位导师指责对方"不够专业"，而另一位则反驳称对方"在搞小团体"。现场气氛一度非常紧张，其他嘉宾和工作人员纷纷上前劝架。',
      '节目组最终被迫暂停录制约两小时。导演组紧急召开闭门会议后，宣布该环节将重新录制。但两位涉事导师均拒绝与对方同台，最终节目组不得不安排其中一位导师的点评环节单独录制。',
      '此事在节目粉丝群中引发轩然大波。支持不同导师的粉丝群体在社交媒体上展开了激烈骂战，相关话题迅速登上热搜榜首位。',
      '有业内人士分析，此次冲突的爆发并非偶然，两位导师此前在其他场合就曾有过不愉快的交集，此次在节目中的火药味其实早有预兆。',
    ],
    relatedArticles: [7, 10, 8],
  },
};

export const allArticles = [
  { id: 1, title: '某千万粉丝主播直播间突然被封，背后原因曝光', category: '网红黑料', time: '12分钟前', reads: '85.2万', tag: '爆' },
  { id: 2, title: '顶流女星深夜密会神秘男子，经纪人紧急公关', category: '明星八卦', time: '28分钟前', reads: '120.6万', tag: '独家' },
  { id: 3, title: '知名综艺录制现场爆发冲突，两位导师当场翻脸', category: '娱乐圈', time: '45分钟前', reads: '96.3万', tag: '爆' },
  { id: 4, title: '网红品牌被曝使用过期原料，生产线视频流出', category: '社会热点', time: '1小时前', reads: '210.8万', tag: '网红黑料' },
  { id: 5, title: '吃播大胃王被曝催吐实锤，粉丝集体脱粉回踩', category: '网红黑料', time: '5小时前', reads: '342.7万', tag: '爆' },
  { id: 6, title: '热门短剧演员被曝学历造假，多所高校回应未查询到', category: '网红黑料', time: '3小时前', reads: '67.9万', tag: '爆' },
  { id: 7, title: '某男团队长恋情曝光，女友竟是圈内知名经纪人', category: '明星八卦', time: '2小时前', reads: '178.4万', tag: '独家' },
  { id: 8, title: '古装剧女主替身演员曝光行业内幕，剧组待遇引热议', category: '娱乐圈', time: '6小时前', reads: '43.5万', tag: '新瓜' },
  { id: 9, title: '网红奶茶品牌加盟商集体维权，总部人去楼空', category: '社会热点', time: '4小时前', reads: '189.2万', tag: '爆' },
  { id: 10, title: '某卫视跨年晚会阵容泄露，多位一线艺人确认加盟', category: '娱乐圈', time: '4小时前', reads: '55.1万', tag: '新瓜' },
  { id: 11, title: '知名歌手演唱会假唱实锤，现场观众上传对比音频', category: '明星八卦', time: '7小时前', reads: '278.6万', tag: '爆' },
  { id: 12, title: '短视频平台算法被曝光，流量分配存在严重不公', category: '社会热点', time: '8小时前', reads: '156.3万', tag: '独家' },
];